/** Step indices and initial step resolution for welcome onboarding. */

export const STEP_INDEX = {
  displayName: 0,
  task: 1,
  project: 2,
  subtask: 3,
};

/** Content steps counted in the progress bar (displayName excluded). */
export const WELCOME_PROGRESS_TOTAL = 3;

/**
 * Progress step number for the bar / "Stap X van Y".
 * displayName → 0 (bar at 0%, no Stap label); task/project/subtask → 1..3.
 */
export function getWelcomeProgressStepNumber(step) {
  return STEP_INDEX[step] ?? 0;
}

export function getWelcomeProgressPercent(stepNumber) {
  if (stepNumber <= 0) {
    return 0;
  }
  return Math.round((stepNumber / WELCOME_PROGRESS_TOTAL) * 100);
}

export function resolveInitialWelcomeStep(user, profileDisplayName) {
  if (user?.isAnonymous) {
    return 'task';
  }
  if (profileDisplayName?.trim()) {
    return 'task';
  }
  return 'displayName';
}
